import { render, staticRenderFns } from "./AedesAegypti.vue?vue&type=template&id=2f67ec36&scoped=true"
import script from "./AedesAegypti.vue?vue&type=script&lang=js"
export * from "./AedesAegypti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f67ec36",
  null
  
)

export default component.exports